// extracted by mini-css-extract-plugin
module.exports = {"what-clothes-cost":"style_what-clothes-cost__5uXEt","gallery":"style_gallery__vQ116","imageContainer":"style_imageContainer__usiRn"};